import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import DashboardPage from "../pages/dashboard/DashboardPage";
import ProviderListPage from "../pages/bookings/ProviderListPage";
import UserListPage from "../pages/users/UserListPage";
import LoginPage from "../pages/auth/LoginPage";
import Layout from "../components/layout/Layout";
import NotificationPage from "../pages/notifications/NotificationPage";
import ReportsPage from "../pages/reports/RepotsPage";
import PaymentsPage from "../pages/payments/PaymentPage";

import { useSelector } from "react-redux";
import { RootState } from "../store";
import { COMMON_STRINGS } from "../constants";

const AppRoutes = () => {
  const token = useSelector((state: RootState) => state.auth.token);
  const isAuth = !!token;

  return (
    <BrowserRouter>
      <Routes>
        {/* Default */}
        <Route
          path="/"
          element={
            isAuth ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* Login */}
        <Route
          path="/login"
          element={
            isAuth ? <Navigate to="/dashboard" replace /> : <LoginPage />
          }
        />

        {/* 🔥 Protected Routes */}
        <Route
          element={
            isAuth ? <Layout /> : <Navigate to="/login" replace />
          }
        >
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/provider" element={<ProviderListPage />} />
          <Route path="/users" element={<UserListPage />} />
          <Route path="/notifications" element={<NotificationPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/payments" element={<PaymentsPage />} />
        </Route>

        {/* 404 */}
        <Route path="*" element={<div>{COMMON_STRINGS.NOT_FOUND}</div>} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;